import { render, staticRenderFns } from "./bottom-nav.vue?vue&type=template&id=31d378f2&scoped=true"
import script from "./bottom-nav.vue?vue&type=script&lang=js"
export * from "./bottom-nav.vue?vue&type=script&lang=js"
import style0 from "./bottom-nav.vue?vue&type=style&index=0&id=31d378f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d378f2",
  null
  
)

export default component.exports